import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  EConfigActions,
  GetConfig,
  GetConfigFailure,
  GetConfigSuccess
} from '../actions/config.actions';
import { ConfigService } from '@eview/core/config/config.service';

@Injectable()
export class ConfigEffects {
  constructor(private configService: ConfigService) {}

  private readonly actions$ = inject(Actions);

  get$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetConfig>(EConfigActions.GetConfig),
      switchMap(() =>
        this.configService.get().pipe(
          map(payload => (payload ? new GetConfigSuccess(payload) : new GetConfigFailure())),
          catchError(() => of(new GetConfigFailure()))
        )
      )
    )
  );
}
